import lodashGet from 'lodash/get';
import $ from '../core/Dom';

export default el => {
    const iframe = $(el).find('iframe');
    let lastHeight = 0;

    const getIframeOrigin = () => {
        const parser = document.createElement('a');
        parser.href = this.iframe.attr('src');
        return `${parser.protocol}//${parser.host}`;
    };

    const onIframeResize = e => {
        if (e.origin !== getIframeOrigin()) {
            return;
        }

        const height = parseInt(lodashGet(e, 'data.height', 0), 10);
        if (height !== lastHeight) {
            lastHeight = height;
            iframe.height(height);
        }
    };

    const init = () => {
        window.addEventListener('message', onIframeResize);
        iframe.attr('src', iframe.data('src'));
    };

    const destroy = () => {
        window.removeEventListener('message', onIframeResize);
    };

    return {
        init,
        destroy
    };
};
